import type { ReactNode } from 'react';

type Option<V extends string> = { value: V; label: ReactNode };

type Props<V extends string> = {
  value: V;
  onChange: (v: V) => void;
  options: ReadonlyArray<Option<V>>;
  /** Visible above the control, e.g. "Photo". */
  label?: string;
};

/** A tri-state (or n-state) pill group -- one value active at a time, e.g. Any/With/Without. */
export function Segmented<V extends string>({ value, onChange, options, label }: Props<V>) {
  return (
    <div className="segmented-group">
      {label ? <span className="segmented-label">{label}</span> : null}
      <div className="segmented">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`segmented-option ${value === opt.value ? 'active' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
